import { lazy } from 'react'
import { IModuleDefinition } from '../types'

const HouseholdContainer = lazy(() => import('./HouseholdsContainer'))

const moduleDefinition: IModuleDefinition = {
  routeProps: {
    path: '/households/*',
    private: true,
    component: HouseholdContainer
  },
  name: 'Households'
}

export default moduleDefinition
